import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { px as _px, withVars as _withVars, cssRef as _cssRef, mergeExternalProps as _mergeExternalProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("colors__component-1zh4qd", {
  color: "var(--static-styles-13b1z3gr_color)",
  backgroundColor: "var(--static-styles-1dxatigf_backgroundColor)"
});
import React from 'react';
import { PolymorphicWithoutRef } from '../polymorphic';
export const colors = {
  primaryOrange: 'var(--primary-orange-500)',
  primaryOrange600: 'var(--primary-orange-600)',
  primaryOrangeHover: 'var(--primary-orange-700)',
  primaryGreen: 'var(--primary-green-500)',
  primaryGreenHover: 'var(--primary-green-600)',
  secondaryGreen: 'var(--primary-green-300)',
  trueBlack: 'var(--system-pure-black)',
  shadesBlack: 'var(--system-black)',
  shadesWhite: 'var(--system-white)',
  shadesParchment: 'var(--system-parchment)',
  statesError: 'var(--system-error)',
  statesSuccess: 'var(--system-success)',
  statesFocus: 'var(---system-focus)',
  statesWarning: 'var(--system-warning)',
  grey50: 'var(--system-grey-50)',
  grey100: 'var(--system-grey-100)',
  grey200: 'var(--system-grey-200)',
  grey300: 'var(--system-grey-300)',
  grey400: 'var(--system-grey-400)',
  grey500: 'var(--system-grey-500)',
  grey600: 'var(--system-grey-600)',
  grey700: 'var(--system-grey-700)',
  grey800: 'var(--system-grey-800)',
  grey900: 'var(--system-grey-900)',
  boxShadow: 'var(--box-shadow)'
};
export type ColorProps = {
  color?: keyof typeof colors;
  backgroundColor?: keyof typeof colors;
};
const Color = <C extends React.ElementType = 'div',>({
  color,
  backgroundColor,
  as,
  ...props
}: PolymorphicWithoutRef<C, ColorProps>): JSX.Element => {
  const Component = as || 'div';
  return <Component {..._mergeExternalProps(props, {
    css: _withVars(_staticStyles, {
      "--static-styles-13b1z3gr_color": _px((() => {
        if (color && colors[color]) {
          return colors[color];
        }
        return undefined;
      })()),
      "--static-styles-1dxatigf_backgroundColor": _px((() => {
        if (backgroundColor && colors[backgroundColor]) {
          return colors[backgroundColor];
        }
        return undefined;
      })())
    })
  })} />;
};
export default Color;